import styled from "styled-components";
import { hexToRgba } from "../utils/helper";

export const StyledTag = styled.div<{ $color?: string; $circleColor?: string, height?: number, fontSize?: number, borderRadius?: number }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: ${({ borderRadius }) => borderRadius ? borderRadius + 'px' : '50px'};
  font-size: ${({ fontSize }) => fontSize ? fontSize + 'px' : '10px'} ;
  height: ${({ height }) => height ? height + 'px' : 'auto'};
  font-weight: 600;
  font-style: 12px;
  font-family: "Raleway", sans-serif;
  background: ${({ $circleColor }) =>
    $circleColor ? `${hexToRgba($circleColor, 0.1)}` : "#0000001a"}; // 0.1 = 10% opacity
  color: ${({ $circleColor }) => $circleColor};
  position: relative;

`;